import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {RequestService} from '../request/request.service';
import {Observable} from 'rxjs';
import {DeviceProductListModel} from '../../../shared/models/device-product.model';

@Injectable()
export class DeviceProductService {
  apiUrl = environment.apiRoot;

  constructor(private reqService: RequestService) {
  }

  get(filter?): Observable<DeviceProductListModel> {
    const req = {
      url: this.apiUrl + 'Product',
      options: {
        params: filter
      }
    };

    return this.reqService.getRequest(req);
  }

}
